export const triggerModes = {
  mouseOver: 'mouseover',
  click: 'click'
};

export const actionModes = {
  overlay: 'overlay',
  standalone: 'standalone',
  link: 'link'
};

export const displayModes = {
  button: 'button',
  poster: 'poster',
  text: 'text',
  phrase: 'phrase',
  iframe: 'iframe', // special mode for tracking iframe displays inside vulines
};

export const renderModes = {
  inline: 'inline',
  vuphrase: 'vuphrase',
  vuline: 'vuline',
  vupopup: 'vupopup', // card-based popup
  iframeVupopup: 'iframe_vupopup', // popup with non-card Ad (renders in iframe)
  nonIframeVupopup: 'non_iframe_vupopup', // popup with non-card Ad
  iframeBottomBanner: 'iframe_bottom_banner', // banner with non-card Ad (renders in iframe)
  nonIframeBottomBanner: 'non_iframe_bottom_banner', // banner with non-card Ad
  plainIframe: 'plain_iframe' // non-publisher iframe ad
};

export const snippetDefaults = {
  headingSelector: 'h1',
  searchSelector: 'p'
};

export const redirectPresetFrameContainerId = 'vup-cookieFrameContainer';
export const cardFrameContainerId = 'vup-cardFrameContainer';
export const popupAdContainerId = 'vup-PopupAdContainer';
export const publisherTrackingContainerId = 'vup-PublisherTrackingContainer';
export const pollVuCardContainerRootId = 'vup-pollVuCardContainer';
